import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import FaviconGenerator from '../../components/FaviconGenerator';

const FaviconPage: React.FC = () => (
  <ToolLayout
    title="Favicon Generator - Create Website Icons | AllTools"
    description="Generate favicons for your website in all sizes. Preview in browser tab. Free favicon maker tool."
    canonicalPath="/favicon-generator"
  >
    <FaviconGenerator />
  </ToolLayout>
);

export default FaviconPage;
